import { p as ue, j as tt } from "./jsx-runtime.js";
import { useMemo as rt, useReducer as nt, createContext as ot } from "react";
import { u as Se, c as at, a as st } from "./util.js";
import { r as Je, a as it, p as ct, b as ut } from "./index10.js";
import { r as ft, u as De, c as lt, a as dt } from "./utils.js";
async function gt(a, s) {
  const g = a.getReader();
  let l;
  for (; !(l = await g.read()).done; )
    s(l.value);
}
function pt(a) {
  let s, g, l, i = !1;
  return function(M) {
    s === void 0 ? (s = M, g = 0, l = -1) : s = mt(s, M);
    const V = s.length;
    let k = 0;
    for (; g < V; ) {
      i && (s[g] === 10 && (k = ++g), i = !1);
      let H = -1;
      for (; g < V && H === -1; ++g)
        switch (s[g]) {
          case 58:
            l === -1 && (l = g - k);
            break;
          case 13:
            i = !0;
          case 10:
            H = g;
            break;
        }
      if (H === -1)
        break;
      a(s.subarray(k, H), l), k = g, l = -1;
    }
    k === V ? s = void 0 : k !== 0 && (s = s.subarray(k), g -= k);
  };
}
function ht(a, s, g) {
  let l = Ue();
  const i = new TextDecoder();
  return function(M, V) {
    if (M.length === 0)
      g == null || g(l), l = Ue();
    else if (V > 0) {
      const k = i.decode(M.subarray(0, V)), H = V + (M[V + 1] === 32 ? 2 : 1), X = i.decode(M.subarray(H));
      switch (k) {
        case "data":
          l.data = l.data ? l.data + `
` + X : X;
          break;
        case "event":
          l.event = X;
          break;
        case "id":
          a(l.id = X);
          break;
        case "retry":
          const J = parseInt(X, 10);
          isNaN(J) || s(l.retry = J);
          break;
      }
    }
  };
}
function mt(a, s) {
  const g = new Uint8Array(a.length + s.length);
  return g.set(a), g.set(s, a.length), g;
}
function Ue() {
  return {
    data: "",
    event: "",
    id: "",
    retry: void 0
  };
}
var yt = globalThis && globalThis.__rest || function(a, s) {
  var g = {};
  for (var l in a)
    Object.prototype.hasOwnProperty.call(a, l) && s.indexOf(l) < 0 && (g[l] = a[l]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, l = Object.getOwnPropertySymbols(a); i < l.length; i++)
      s.indexOf(l[i]) < 0 && Object.prototype.propertyIsEnumerable.call(a, l[i]) && (g[l[i]] = a[l[i]]);
  return g;
};
const _e = "text/event-stream", vt = 1e3, $e = "last-event-id";
function bt(a, s) {
  var { signal: g, headers: l, onopen: i, onmessage: w, onclose: M, onerror: V, openWhenHidden: k, fetch: H } = s, X = yt(s, ["signal", "headers", "onopen", "onmessage", "onclose", "onerror", "openWhenHidden", "fetch"]);
  return new Promise((J, W) => {
    const O = Object.assign({}, l);
    O.accept || (O.accept = _e);
    let A;
    function Y() {
      A.abort(), document.hidden || f();
    }
    k || document.addEventListener("visibilitychange", Y);
    let q = vt, j = 0;
    function $() {
      document.removeEventListener("visibilitychange", Y), window.clearTimeout(j), A.abort();
    }
    g == null || g.addEventListener("abort", () => {
      $(), J();
    });
    const ie = H ?? window.fetch, te = i ?? wt;
    async function f() {
      var u;
      A = new AbortController();
      try {
        const h = await ie(a, Object.assign(Object.assign({}, X), { headers: O, signal: A.signal }));
        await te(h), await gt(h.body, pt(ht((y) => {
          y ? O[$e] = y : delete O[$e];
        }, (y) => {
          q = y;
        }, w))), M == null || M(), $(), J();
      } catch (h) {
        if (!A.signal.aborted)
          try {
            const y = (u = V == null ? void 0 : V(h)) !== null && u !== void 0 ? u : q;
            window.clearTimeout(j), j = window.setTimeout(f, y);
          } catch (y) {
            $(), W(y);
          }
      }
    }
    f();
  });
}
function wt(a) {
  const s = a.headers.get("content-type");
  if (!(s != null && s.startsWith(_e)))
    throw new Error(`Expected content-type to be ${_e}, Actual: ${s}`);
}
var Re = { exports: {} }, je = {}, Fe;
function Xe() {
  if (Fe)
    return je;
  Fe = 1;
  function a(f) {
    "@babel/helpers - typeof";
    return a = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(u) {
      return typeof u;
    } : function(u) {
      return u && typeof Symbol == "function" && u.constructor === Symbol && u !== Symbol.prototype ? "symbol" : typeof u;
    }, a(f);
  }
  function s(f, u) {
    for (var h = 0; h < u.length; h++) {
      var y = u[h];
      y.enumerable = y.enumerable || !1, y.configurable = !0, "value" in y && (y.writable = !0), Object.defineProperty(f, l(y.key), y);
    }
  }
  function g(f, u, h) {
    return u && s(f.prototype, u), h && s(f, h), Object.defineProperty(f, "prototype", { writable: !1 }), f;
  }
  function l(f) {
    var u = i(f, "string");
    return a(u) === "symbol" ? u : String(u);
  }
  function i(f, u) {
    if (a(f) !== "object" || f === null)
      return f;
    var h = f[Symbol.toPrimitive];
    if (h !== void 0) {
      var y = h.call(f, u || "default");
      if (a(y) !== "object")
        return y;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (u === "string" ? String : Number)(f);
  }
  function w(f, u) {
    if (!(f instanceof u))
      throw new TypeError("Cannot call a class as a function");
  }
  function M(f, u) {
    if (typeof u != "function" && u !== null)
      throw new TypeError("Super expression must either be null or a function");
    f.prototype = Object.create(u && u.prototype, { constructor: { value: f, writable: !0, configurable: !0 } }), Object.defineProperty(f, "prototype", { writable: !1 }), u && V(f, u);
  }
  function V(f, u) {
    return V = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(y, D) {
      return y.__proto__ = D, y;
    }, V(f, u);
  }
  function k(f) {
    var u = J();
    return function() {
      var y = W(f), D;
      if (u) {
        var N = W(this).constructor;
        D = Reflect.construct(y, arguments, N);
      } else
        D = y.apply(this, arguments);
      return H(this, D);
    };
  }
  function H(f, u) {
    if (u && (a(u) === "object" || typeof u == "function"))
      return u;
    if (u !== void 0)
      throw new TypeError("Derived constructors may only return object or undefined");
    return X(f);
  }
  function X(f) {
    if (f === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return f;
  }
  function J() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  function W(f) {
    return W = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(h) {
      return h.__proto__ || Object.getPrototypeOf(h);
    }, W(f);
  }
  var O = {}, A, Y;
  function q(f, u, h) {
    h || (h = Error);
    function y(N, Z, T) {
      return typeof u == "string" ? u : u(N, Z, T);
    }
    var D = /* @__PURE__ */ function(N) {
      M(T, N);
      var Z = k(T);
      function T(_, oe, ae) {
        var re;
        return w(this, T), re = Z.call(this, y(_, oe, ae)), re.code = f, re;
      }
      return g(T);
    }(h);
    O[f] = D;
  }
  function j(f, u) {
    if (Array.isArray(f)) {
      var h = f.length;
      return f = f.map(function(y) {
        return String(y);
      }), h > 2 ? "one of ".concat(u, " ").concat(f.slice(0, h - 1).join(", "), ", or ") + f[h - 1] : h === 2 ? "one of ".concat(u, " ").concat(f[0], " or ").concat(f[1]) : "of ".concat(u, " ").concat(f[0]);
    } else
      return "of ".concat(u, " ").concat(String(f));
  }
  function $(f, u, h) {
    return f.substr(!h || h < 0 ? 0 : +h, u.length) === u;
  }
  function ie(f, u, h) {
    return (h === void 0 || h > f.length) && (h = f.length), f.substring(h - u.length, h) === u;
  }
  function te(f, u, h) {
    return typeof h != "number" && (h = 0), h + u.length > f.length ? !1 : f.indexOf(u, h) !== -1;
  }
  return q("ERR_AMBIGUOUS_ARGUMENT", 'The "%s" argument is ambiguous. %s', TypeError), q("ERR_INVALID_ARG_TYPE", function(f, u, h) {
    A === void 0 && (A = Ce()), A(typeof f == "string", "'name' must be a string");
    var y;
    typeof u == "string" && $(u, "not ") ? (y = "must not be", u = u.replace(/^not /, "")) : y = "must be";
    var D;
    if (ie(f, " argument"))
      D = "The ".concat(f, " ").concat(y, " ").concat(j(u, "type"));
    else {
      var N = te(f, ".") ? "property" : "argument";
      D = 'The "'.concat(f, '" ').concat(N, " ").concat(y, " ").concat(j(u, "type"));
    }
    return D += ". Received type ".concat(a(h)), D;
  }, TypeError), q("ERR_INVALID_ARG_VALUE", function(f, u) {
    var h = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "is invalid";
    Y === void 0 && (Y = Se);
    var y = Y.inspect(u);
    return y.length > 128 && (y = "".concat(y.slice(0, 128), "...")), "The argument '".concat(f, "' ").concat(h, ". Received ").concat(y);
  }, TypeError), q("ERR_INVALID_RETURN_VALUE", function(f, u, h) {
    var y;
    return h && h.constructor && h.constructor.name ? y = "instance of ".concat(h.constructor.name) : y = "type ".concat(a(h)), "Expected ".concat(f, ' to be returned from the "').concat(u, '"') + " function but got ".concat(y, ".");
  }, TypeError), q("ERR_MISSING_ARGS", function() {
    for (var f = arguments.length, u = new Array(f), h = 0; h < f; h++)
      u[h] = arguments[h];
    A === void 0 && (A = Ce()), A(u.length > 0, "At least one arg needs to be specified");
    var y = "The ", D = u.length;
    switch (u = u.map(function(N) {
      return '"'.concat(N, '"');
    }), D) {
      case 1:
        y += "".concat(u[0], " argument");
        break;
      case 2:
        y += "".concat(u[0], " and ").concat(u[1], " arguments");
        break;
      default:
        y += u.slice(0, D - 1).join(", "), y += ", and ".concat(u[D - 1], " arguments");
        break;
    }
    return "".concat(y, " must be specified");
  }, TypeError), je.codes = O, je;
}
var Me, Le;
function Et() {
  if (Le)
    return Me;
  Le = 1;
  function a(d, p) {
    var E = Object.keys(d);
    if (Object.getOwnPropertySymbols) {
      var v = Object.getOwnPropertySymbols(d);
      p && (v = v.filter(function(P) {
        return Object.getOwnPropertyDescriptor(d, P).enumerable;
      })), E.push.apply(E, v);
    }
    return E;
  }
  function s(d) {
    for (var p = 1; p < arguments.length; p++) {
      var E = arguments[p] != null ? arguments[p] : {};
      p % 2 ? a(Object(E), !0).forEach(function(v) {
        g(d, v, E[v]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(d, Object.getOwnPropertyDescriptors(E)) : a(Object(E)).forEach(function(v) {
        Object.defineProperty(d, v, Object.getOwnPropertyDescriptor(E, v));
      });
    }
    return d;
  }
  function g(d, p, E) {
    return p = M(p), p in d ? Object.defineProperty(d, p, { value: E, enumerable: !0, configurable: !0, writable: !0 }) : d[p] = E, d;
  }
  function l(d, p) {
    if (!(d instanceof p))
      throw new TypeError("Cannot call a class as a function");
  }
  function i(d, p) {
    for (var E = 0; E < p.length; E++) {
      var v = p[E];
      v.enumerable = v.enumerable || !1, v.configurable = !0, "value" in v && (v.writable = !0), Object.defineProperty(d, M(v.key), v);
    }
  }
  function w(d, p, E) {
    return p && i(d.prototype, p), E && i(d, E), Object.defineProperty(d, "prototype", { writable: !1 }), d;
  }
  function M(d) {
    var p = V(d, "string");
    return $(p) === "symbol" ? p : String(p);
  }
  function V(d, p) {
    if ($(d) !== "object" || d === null)
      return d;
    var E = d[Symbol.toPrimitive];
    if (E !== void 0) {
      var v = E.call(d, p || "default");
      if ($(v) !== "object")
        return v;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (p === "string" ? String : Number)(d);
  }
  function k(d, p) {
    if (typeof p != "function" && p !== null)
      throw new TypeError("Super expression must either be null or a function");
    d.prototype = Object.create(p && p.prototype, { constructor: { value: d, writable: !0, configurable: !0 } }), Object.defineProperty(d, "prototype", { writable: !1 }), p && q(d, p);
  }
  function H(d) {
    var p = A();
    return function() {
      var v = j(d), P;
      if (p) {
        var F = j(this).constructor;
        P = Reflect.construct(v, arguments, F);
      } else
        P = v.apply(this, arguments);
      return X(this, P);
    };
  }
  function X(d, p) {
    if (p && ($(p) === "object" || typeof p == "function"))
      return p;
    if (p !== void 0)
      throw new TypeError("Derived constructors may only return object or undefined");
    return J(d);
  }
  function J(d) {
    if (d === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return d;
  }
  function W(d) {
    var p = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
    return W = function(v) {
      if (v === null || !Y(v))
        return v;
      if (typeof v != "function")
        throw new TypeError("Super expression must either be null or a function");
      if (typeof p < "u") {
        if (p.has(v))
          return p.get(v);
        p.set(v, P);
      }
      function P() {
        return O(v, arguments, j(this).constructor);
      }
      return P.prototype = Object.create(v.prototype, { constructor: { value: P, enumerable: !1, writable: !0, configurable: !0 } }), q(P, v);
    }, W(d);
  }
  function O(d, p, E) {
    return A() ? O = Reflect.construct.bind() : O = function(P, F, Q) {
      var G = [null];
      G.push.apply(G, F);
      var o = Function.bind.apply(P, G), e = new o();
      return Q && q(e, Q.prototype), e;
    }, O.apply(null, arguments);
  }
  function A() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  function Y(d) {
    return Function.toString.call(d).indexOf("[native code]") !== -1;
  }
  function q(d, p) {
    return q = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(v, P) {
      return v.__proto__ = P, v;
    }, q(d, p);
  }
  function j(d) {
    return j = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(E) {
      return E.__proto__ || Object.getPrototypeOf(E);
    }, j(d);
  }
  function $(d) {
    "@babel/helpers - typeof";
    return $ = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(p) {
      return typeof p;
    } : function(p) {
      return p && typeof Symbol == "function" && p.constructor === Symbol && p !== Symbol.prototype ? "symbol" : typeof p;
    }, $(d);
  }
  var ie = Se, te = ie.inspect, f = Xe(), u = f.codes.ERR_INVALID_ARG_TYPE;
  function h(d, p, E) {
    return (E === void 0 || E > d.length) && (E = d.length), d.substring(E - p.length, E) === p;
  }
  function y(d, p) {
    if (p = Math.floor(p), d.length == 0 || p == 0)
      return "";
    var E = d.length * p;
    for (p = Math.floor(Math.log(p) / Math.log(2)); p; )
      d += d, p--;
    return d += d.substring(0, E - d.length), d;
  }
  var D = "", N = "", Z = "", T = "", _ = {
    deepStrictEqual: "Expected values to be strictly deep-equal:",
    strictEqual: "Expected values to be strictly equal:",
    strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
    deepEqual: "Expected values to be loosely deep-equal:",
    equal: "Expected values to be loosely equal:",
    notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
    notStrictEqual: 'Expected "actual" to be strictly unequal to:',
    notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
    notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
    notEqual: 'Expected "actual" to be loosely unequal to:',
    notIdentical: "Values identical but not reference-equal:"
  }, oe = 10;
  function ae(d) {
    var p = Object.keys(d), E = Object.create(Object.getPrototypeOf(d));
    return p.forEach(function(v) {
      E[v] = d[v];
    }), Object.defineProperty(E, "message", {
      value: d.message
    }), E;
  }
  function re(d) {
    return te(d, {
      compact: !1,
      customInspect: !1,
      depth: 1e3,
      maxArrayLength: 1 / 0,
      // Assert compares only enumerable properties (with a few exceptions).
      showHidden: !1,
      // Having a long line as error is better than wrapping the line for
      // comparison for now.
      // TODO(BridgeAR): `breakLength` should be limited as soon as soon as we
      // have meta information about the inspected properties (i.e., know where
      // in what line the property starts and ends).
      breakLength: 1 / 0,
      // Assert does not detect proxies currently.
      showProxy: !1,
      sorted: !0,
      // Inspect getters as we also check them when comparing entries.
      getters: !0
    });
  }
  function me(d, p, E) {
    var v = "", P = "", F = 0, Q = "", G = !1, o = re(d), e = o.split(`
`), r = re(p).split(`
`), c = 0, b = "";
    if (E === "strictEqual" && $(d) === "object" && $(p) === "object" && d !== null && p !== null && (E = "strictEqualObject"), e.length === 1 && r.length === 1 && e[0] !== r[0]) {
      var I = e[0].length + r[0].length;
      if (I <= oe) {
        if (($(d) !== "object" || d === null) && ($(p) !== "object" || p === null) && (d !== 0 || p !== 0))
          return "".concat(_[E], `

`) + "".concat(e[0], " !== ").concat(r[0], `
`);
      } else if (E !== "strictEqualObject") {
        var C = ue.stderr && ue.stderr.isTTY ? ue.stderr.columns : 80;
        if (I < C) {
          for (; e[0][c] === r[0][c]; )
            c++;
          c > 2 && (b = `
  `.concat(y(" ", c), "^"), c = 0);
        }
      }
    }
    for (var z = e[e.length - 1], K = r[r.length - 1]; z === K && (c++ < 2 ? Q = `
  `.concat(z).concat(Q) : v = z, e.pop(), r.pop(), !(e.length === 0 || r.length === 0)); )
      z = e[e.length - 1], K = r[r.length - 1];
    var fe = Math.max(e.length, r.length);
    if (fe === 0) {
      var pe = o.split(`
`);
      if (pe.length > 30)
        for (pe[26] = "".concat(D, "...").concat(T); pe.length > 27; )
          pe.pop();
      return "".concat(_.notIdentical, `

`).concat(pe.join(`
`), `
`);
    }
    c > 3 && (Q = `
`.concat(D, "...").concat(T).concat(Q), G = !0), v !== "" && (Q = `
  `.concat(v).concat(Q), v = "");
    var se = 0, ve = _[E] + `
`.concat(N, "+ actual").concat(T, " ").concat(Z, "- expected").concat(T), Oe = " ".concat(D, "...").concat(T, " Lines skipped");
    for (c = 0; c < fe; c++) {
      var ce = c - F;
      if (e.length < c + 1)
        ce > 1 && c > 2 && (ce > 4 ? (P += `
`.concat(D, "...").concat(T), G = !0) : ce > 3 && (P += `
  `.concat(r[c - 2]), se++), P += `
  `.concat(r[c - 1]), se++), F = c, v += `
`.concat(Z, "-").concat(T, " ").concat(r[c]), se++;
      else if (r.length < c + 1)
        ce > 1 && c > 2 && (ce > 4 ? (P += `
`.concat(D, "...").concat(T), G = !0) : ce > 3 && (P += `
  `.concat(e[c - 2]), se++), P += `
  `.concat(e[c - 1]), se++), F = c, P += `
`.concat(N, "+").concat(T, " ").concat(e[c]), se++;
      else {
        var he = r[c], le = e[c], t = le !== he && (!h(le, ",") || le.slice(0, -1) !== he);
        t && h(he, ",") && he.slice(0, -1) === le && (t = !1, le += ","), t ? (ce > 1 && c > 2 && (ce > 4 ? (P += `
`.concat(D, "...").concat(T), G = !0) : ce > 3 && (P += `
  `.concat(e[c - 2]), se++), P += `
  `.concat(e[c - 1]), se++), F = c, P += `
`.concat(N, "+").concat(T, " ").concat(le), v += `
`.concat(Z, "-").concat(T, " ").concat(he), se += 2) : (P += v, v = "", (ce === 1 || c === 0) && (P += `
  `.concat(le), se++));
      }
      if (se > 20 && c < fe - 2)
        return "".concat(ve).concat(Oe, `
`).concat(P, `
`).concat(D, "...").concat(T).concat(v, `
`) + "".concat(D, "...").concat(T);
    }
    return "".concat(ve).concat(G ? Oe : "", `
`).concat(P).concat(v).concat(Q).concat(b);
  }
  var ge = /* @__PURE__ */ function(d, p) {
    k(v, d);
    var E = H(v);
    function v(P) {
      var F;
      if (l(this, v), $(P) !== "object" || P === null)
        throw new u("options", "Object", P);
      var Q = P.message, G = P.operator, o = P.stackStartFn, e = P.actual, r = P.expected, c = Error.stackTraceLimit;
      if (Error.stackTraceLimit = 0, Q != null)
        F = E.call(this, String(Q));
      else if (ue.stderr && ue.stderr.isTTY && (ue.stderr && ue.stderr.getColorDepth && ue.stderr.getColorDepth() !== 1 ? (D = "\x1B[34m", N = "\x1B[32m", T = "\x1B[39m", Z = "\x1B[31m") : (D = "", N = "", T = "", Z = "")), $(e) === "object" && e !== null && $(r) === "object" && r !== null && "stack" in e && e instanceof Error && "stack" in r && r instanceof Error && (e = ae(e), r = ae(r)), G === "deepStrictEqual" || G === "strictEqual")
        F = E.call(this, me(e, r, G));
      else if (G === "notDeepStrictEqual" || G === "notStrictEqual") {
        var b = _[G], I = re(e).split(`
`);
        if (G === "notStrictEqual" && $(e) === "object" && e !== null && (b = _.notStrictEqualObject), I.length > 30)
          for (I[26] = "".concat(D, "...").concat(T); I.length > 27; )
            I.pop();
        I.length === 1 ? F = E.call(this, "".concat(b, " ").concat(I[0])) : F = E.call(this, "".concat(b, `

`).concat(I.join(`
`), `
`));
      } else {
        var C = re(e), z = "", K = _[G];
        G === "notDeepEqual" || G === "notEqual" ? (C = "".concat(_[G], `

`).concat(C), C.length > 1024 && (C = "".concat(C.slice(0, 1021), "..."))) : (z = "".concat(re(r)), C.length > 512 && (C = "".concat(C.slice(0, 509), "...")), z.length > 512 && (z = "".concat(z.slice(0, 509), "...")), G === "deepEqual" || G === "equal" ? C = "".concat(K, `

`).concat(C, `

should equal

`) : z = " ".concat(G, " ").concat(z)), F = E.call(this, "".concat(C).concat(z));
      }
      return Error.stackTraceLimit = c, F.generatedMessage = !Q, Object.defineProperty(J(F), "name", {
        value: "AssertionError [ERR_ASSERTION]",
        enumerable: !1,
        writable: !0,
        configurable: !0
      }), F.code = "ERR_ASSERTION", F.actual = e, F.expected = r, F.operator = G, Error.captureStackTrace && Error.captureStackTrace(J(F), o), F.stack, F.name = "AssertionError", X(F);
    }
    return w(v, [{
      key: "toString",
      value: function() {
        return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
      }
    }, {
      key: p,
      value: function(F, Q) {
        return te(this, s(s({}, Q), {}, {
          customInspect: !1,
          depth: 0
        }));
      }
    }]), v;
  }(/* @__PURE__ */ W(Error), te.custom);
  return Me = ge, Me;
}
var qe, Be;
function Qe() {
  return Be || (Be = 1, qe = function(s) {
    return s !== s;
  }), qe;
}
var Ne, Ve;
function Ze() {
  if (Ve)
    return Ne;
  Ve = 1;
  var a = Qe();
  return Ne = function() {
    return Number.isNaN && Number.isNaN(NaN) && !Number.isNaN("a") ? Number.isNaN : a;
  }, Ne;
}
var Pe, Ge;
function St() {
  if (Ge)
    return Pe;
  Ge = 1;
  var a = Je(), s = Ze();
  return Pe = function() {
    var l = s();
    return a(Number, { isNaN: l }, {
      isNaN: function() {
        return Number.isNaN !== l;
      }
    }), l;
  }, Pe;
}
var Ae, ke;
function Ot() {
  if (ke)
    return Ae;
  ke = 1;
  var a = at, s = Je(), g = Qe(), l = Ze(), i = St(), w = a(l(), Number);
  return s(w, {
    getPolyfill: l,
    implementation: g,
    shim: i
  }), Ae = w, Ae;
}
var Te, He;
function It() {
  if (He)
    return Te;
  He = 1;
  function a(t, n) {
    return w(t) || i(t, n) || g(t, n) || s();
  }
  function s() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function g(t, n) {
    if (t) {
      if (typeof t == "string")
        return l(t, n);
      var m = Object.prototype.toString.call(t).slice(8, -1);
      if (m === "Object" && t.constructor && (m = t.constructor.name), m === "Map" || m === "Set")
        return Array.from(t);
      if (m === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(m))
        return l(t, n);
    }
  }
  function l(t, n) {
    (n == null || n > t.length) && (n = t.length);
    for (var m = 0, S = new Array(n); m < n; m++)
      S[m] = t[m];
    return S;
  }
  function i(t, n) {
    var m = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
    if (m != null) {
      var S, R, U, x, L = [], B = !0, ee = !1;
      try {
        if (U = (m = m.call(t)).next, n === 0) {
          if (Object(m) !== m)
            return;
          B = !1;
        } else
          for (; !(B = (S = U.call(m)).done) && (L.push(S.value), L.length !== n); B = !0)
            ;
      } catch (ne) {
        ee = !0, R = ne;
      } finally {
        try {
          if (!B && m.return != null && (x = m.return(), Object(x) !== x))
            return;
        } finally {
          if (ee)
            throw R;
        }
      }
      return L;
    }
  }
  function w(t) {
    if (Array.isArray(t))
      return t;
  }
  function M(t) {
    "@babel/helpers - typeof";
    return M = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
      return typeof n;
    } : function(n) {
      return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
    }, M(t);
  }
  var V = /a/g.flags !== void 0, k = function(n) {
    var m = [];
    return n.forEach(function(S) {
      return m.push(S);
    }), m;
  }, H = function(n) {
    var m = [];
    return n.forEach(function(S, R) {
      return m.push([R, S]);
    }), m;
  }, X = Object.is ? Object.is : it(), J = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function() {
    return [];
  }, W = Number.isNaN ? Number.isNaN : Ot();
  function O(t) {
    return t.call.bind(t);
  }
  var A = O(Object.prototype.hasOwnProperty), Y = O(Object.prototype.propertyIsEnumerable), q = O(Object.prototype.toString), j = Se.types, $ = j.isAnyArrayBuffer, ie = j.isArrayBufferView, te = j.isDate, f = j.isMap, u = j.isRegExp, h = j.isSet, y = j.isNativeError, D = j.isBoxedPrimitive, N = j.isNumberObject, Z = j.isStringObject, T = j.isBooleanObject, _ = j.isBigIntObject, oe = j.isSymbolObject, ae = j.isFloat32Array, re = j.isFloat64Array;
  function me(t) {
    if (t.length === 0 || t.length > 10)
      return !0;
    for (var n = 0; n < t.length; n++) {
      var m = t.charCodeAt(n);
      if (m < 48 || m > 57)
        return !0;
    }
    return t.length === 10 && t >= Math.pow(2, 32);
  }
  function ge(t) {
    return Object.keys(t).filter(me).concat(J(t).filter(Object.prototype.propertyIsEnumerable.bind(t)));
  }
  /*!
   * The buffer module from node.js, for the browser.
   *
   * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
   * @license  MIT
   */
  function d(t, n) {
    if (t === n)
      return 0;
    for (var m = t.length, S = n.length, R = 0, U = Math.min(m, S); R < U; ++R)
      if (t[R] !== n[R]) {
        m = t[R], S = n[R];
        break;
      }
    return m < S ? -1 : S < m ? 1 : 0;
  }
  var p = !0, E = !1, v = 0, P = 1, F = 2, Q = 3;
  function G(t, n) {
    return V ? t.source === n.source && t.flags === n.flags : RegExp.prototype.toString.call(t) === RegExp.prototype.toString.call(n);
  }
  function o(t, n) {
    if (t.byteLength !== n.byteLength)
      return !1;
    for (var m = 0; m < t.byteLength; m++)
      if (t[m] !== n[m])
        return !1;
    return !0;
  }
  function e(t, n) {
    return t.byteLength !== n.byteLength ? !1 : d(new Uint8Array(t.buffer, t.byteOffset, t.byteLength), new Uint8Array(n.buffer, n.byteOffset, n.byteLength)) === 0;
  }
  function r(t, n) {
    return t.byteLength === n.byteLength && d(new Uint8Array(t), new Uint8Array(n)) === 0;
  }
  function c(t, n) {
    return N(t) ? N(n) && X(Number.prototype.valueOf.call(t), Number.prototype.valueOf.call(n)) : Z(t) ? Z(n) && String.prototype.valueOf.call(t) === String.prototype.valueOf.call(n) : T(t) ? T(n) && Boolean.prototype.valueOf.call(t) === Boolean.prototype.valueOf.call(n) : _(t) ? _(n) && BigInt.prototype.valueOf.call(t) === BigInt.prototype.valueOf.call(n) : oe(n) && Symbol.prototype.valueOf.call(t) === Symbol.prototype.valueOf.call(n);
  }
  function b(t, n, m, S) {
    if (t === n)
      return t !== 0 ? !0 : m ? X(t, n) : !0;
    if (m) {
      if (M(t) !== "object")
        return typeof t == "number" && W(t) && W(n);
      if (M(n) !== "object" || t === null || n === null || Object.getPrototypeOf(t) !== Object.getPrototypeOf(n))
        return !1;
    } else {
      if (t === null || M(t) !== "object")
        return n === null || M(n) !== "object" ? t == n : !1;
      if (n === null || M(n) !== "object")
        return !1;
    }
    var R = q(t), U = q(n);
    if (R !== U)
      return !1;
    if (Array.isArray(t)) {
      if (t.length !== n.length)
        return !1;
      var x = ge(t), L = ge(n);
      return x.length !== L.length ? !1 : C(t, n, m, S, P, x);
    }
    if (R === "[object Object]" && (!f(t) && f(n) || !h(t) && h(n)))
      return !1;
    if (te(t)) {
      if (!te(n) || Date.prototype.getTime.call(t) !== Date.prototype.getTime.call(n))
        return !1;
    } else if (u(t)) {
      if (!u(n) || !G(t, n))
        return !1;
    } else if (y(t) || t instanceof Error) {
      if (t.message !== n.message || t.name !== n.name)
        return !1;
    } else if (ie(t)) {
      if (!m && (ae(t) || re(t))) {
        if (!o(t, n))
          return !1;
      } else if (!e(t, n))
        return !1;
      var B = ge(t), ee = ge(n);
      return B.length !== ee.length ? !1 : C(t, n, m, S, v, B);
    } else {
      if (h(t))
        return !h(n) || t.size !== n.size ? !1 : C(t, n, m, S, F);
      if (f(t))
        return !f(n) || t.size !== n.size ? !1 : C(t, n, m, S, Q);
      if ($(t)) {
        if (!r(t, n))
          return !1;
      } else if (D(t) && !c(t, n))
        return !1;
    }
    return C(t, n, m, S, v);
  }
  function I(t, n) {
    return n.filter(function(m) {
      return Y(t, m);
    });
  }
  function C(t, n, m, S, R, U) {
    if (arguments.length === 5) {
      U = Object.keys(t);
      var x = Object.keys(n);
      if (U.length !== x.length)
        return !1;
    }
    for (var L = 0; L < U.length; L++)
      if (!A(n, U[L]))
        return !1;
    if (m && arguments.length === 5) {
      var B = J(t);
      if (B.length !== 0) {
        var ee = 0;
        for (L = 0; L < B.length; L++) {
          var ne = B[L];
          if (Y(t, ne)) {
            if (!Y(n, ne))
              return !1;
            U.push(ne), ee++;
          } else if (Y(n, ne))
            return !1;
        }
        var be = J(n);
        if (B.length !== be.length && I(n, be).length !== ee)
          return !1;
      } else {
        var ye = J(n);
        if (ye.length !== 0 && I(n, ye).length !== 0)
          return !1;
      }
    }
    if (U.length === 0 && (R === v || R === P && t.length === 0 || t.size === 0))
      return !0;
    if (S === void 0)
      S = {
        val1: /* @__PURE__ */ new Map(),
        val2: /* @__PURE__ */ new Map(),
        position: 0
      };
    else {
      var we = S.val1.get(t);
      if (we !== void 0) {
        var de = S.val2.get(n);
        if (de !== void 0)
          return we === de;
      }
      S.position++;
    }
    S.val1.set(t, S.position), S.val2.set(n, S.position);
    var Ee = ce(t, n, m, U, S, R);
    return S.val1.delete(t), S.val2.delete(n), Ee;
  }
  function z(t, n, m, S) {
    for (var R = k(t), U = 0; U < R.length; U++) {
      var x = R[U];
      if (b(n, x, m, S))
        return t.delete(x), !0;
    }
    return !1;
  }
  function K(t) {
    switch (M(t)) {
      case "undefined":
        return null;
      case "object":
        return;
      case "symbol":
        return !1;
      case "string":
        t = +t;
      case "number":
        if (W(t))
          return !1;
    }
    return !0;
  }
  function fe(t, n, m) {
    var S = K(m);
    return S ?? (n.has(S) && !t.has(S));
  }
  function pe(t, n, m, S, R) {
    var U = K(m);
    if (U != null)
      return U;
    var x = n.get(U);
    return x === void 0 && !n.has(U) || !b(S, x, !1, R) ? !1 : !t.has(U) && b(S, x, !1, R);
  }
  function se(t, n, m, S) {
    for (var R = null, U = k(t), x = 0; x < U.length; x++) {
      var L = U[x];
      if (M(L) === "object" && L !== null)
        R === null && (R = /* @__PURE__ */ new Set()), R.add(L);
      else if (!n.has(L)) {
        if (m || !fe(t, n, L))
          return !1;
        R === null && (R = /* @__PURE__ */ new Set()), R.add(L);
      }
    }
    if (R !== null) {
      for (var B = k(n), ee = 0; ee < B.length; ee++) {
        var ne = B[ee];
        if (M(ne) === "object" && ne !== null) {
          if (!z(R, ne, m, S))
            return !1;
        } else if (!m && !t.has(ne) && !z(R, ne, m, S))
          return !1;
      }
      return R.size === 0;
    }
    return !0;
  }
  function ve(t, n, m, S, R, U) {
    for (var x = k(t), L = 0; L < x.length; L++) {
      var B = x[L];
      if (b(m, B, R, U) && b(S, n.get(B), R, U))
        return t.delete(B), !0;
    }
    return !1;
  }
  function Oe(t, n, m, S) {
    for (var R = null, U = H(t), x = 0; x < U.length; x++) {
      var L = a(U[x], 2), B = L[0], ee = L[1];
      if (M(B) === "object" && B !== null)
        R === null && (R = /* @__PURE__ */ new Set()), R.add(B);
      else {
        var ne = n.get(B);
        if (ne === void 0 && !n.has(B) || !b(ee, ne, m, S)) {
          if (m || !pe(t, n, B, ee, S))
            return !1;
          R === null && (R = /* @__PURE__ */ new Set()), R.add(B);
        }
      }
    }
    if (R !== null) {
      for (var be = H(n), ye = 0; ye < be.length; ye++) {
        var we = a(be[ye], 2), de = we[0], Ee = we[1];
        if (M(de) === "object" && de !== null) {
          if (!ve(R, t, de, Ee, m, S))
            return !1;
        } else if (!m && (!t.has(de) || !b(t.get(de), Ee, !1, S)) && !ve(R, t, de, Ee, !1, S))
          return !1;
      }
      return R.size === 0;
    }
    return !0;
  }
  function ce(t, n, m, S, R, U) {
    var x = 0;
    if (U === F) {
      if (!se(t, n, m, R))
        return !1;
    } else if (U === Q) {
      if (!Oe(t, n, m, R))
        return !1;
    } else if (U === P)
      for (; x < t.length; x++)
        if (A(t, x)) {
          if (!A(n, x) || !b(t[x], n[x], m, R))
            return !1;
        } else {
          if (A(n, x))
            return !1;
          for (var L = Object.keys(t); x < L.length; x++) {
            var B = L[x];
            if (!A(n, B) || !b(t[B], n[B], m, R))
              return !1;
          }
          return L.length === Object.keys(n).length;
        }
    for (x = 0; x < S.length; x++) {
      var ee = S[x];
      if (!b(t[ee], n[ee], m, R))
        return !1;
    }
    return !0;
  }
  function he(t, n) {
    return b(t, n, E);
  }
  function le(t, n) {
    return b(t, n, p);
  }
  return Te = {
    isDeepEqual: he,
    isDeepStrictEqual: le
  }, Te;
}
var We;
function Ce() {
  if (We)
    return Re.exports;
  We = 1;
  function a(o) {
    "@babel/helpers - typeof";
    return a = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
      return typeof e;
    } : function(e) {
      return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    }, a(o);
  }
  function s(o, e) {
    for (var r = 0; r < e.length; r++) {
      var c = e[r];
      c.enumerable = c.enumerable || !1, c.configurable = !0, "value" in c && (c.writable = !0), Object.defineProperty(o, l(c.key), c);
    }
  }
  function g(o, e, r) {
    return e && s(o.prototype, e), r && s(o, r), Object.defineProperty(o, "prototype", { writable: !1 }), o;
  }
  function l(o) {
    var e = i(o, "string");
    return a(e) === "symbol" ? e : String(e);
  }
  function i(o, e) {
    if (a(o) !== "object" || o === null)
      return o;
    var r = o[Symbol.toPrimitive];
    if (r !== void 0) {
      var c = r.call(o, e || "default");
      if (a(c) !== "object")
        return c;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (e === "string" ? String : Number)(o);
  }
  function w(o, e) {
    if (!(o instanceof e))
      throw new TypeError("Cannot call a class as a function");
  }
  var M = Xe(), V = M.codes, k = V.ERR_AMBIGUOUS_ARGUMENT, H = V.ERR_INVALID_ARG_TYPE, X = V.ERR_INVALID_ARG_VALUE, J = V.ERR_INVALID_RETURN_VALUE, W = V.ERR_MISSING_ARGS, O = Et(), A = Se, Y = A.inspect, q = Se.types, j = q.isPromise, $ = q.isRegExp, ie = ct(), te = ut(), f = st("RegExp.prototype.test"), u, h;
  function y() {
    var o = It();
    u = o.isDeepEqual, h = o.isDeepStrictEqual;
  }
  var D = !1, N = Re.exports = ae, Z = {};
  function T(o) {
    throw o.message instanceof Error ? o.message : new O(o);
  }
  function _(o, e, r, c, b) {
    var I = arguments.length, C;
    if (I === 0)
      C = "Failed";
    else if (I === 1)
      r = o, o = void 0;
    else {
      if (D === !1) {
        D = !0;
        var z = ue.emitWarning ? ue.emitWarning : console.warn.bind(console);
        z("assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.", "DeprecationWarning", "DEP0094");
      }
      I === 2 && (c = "!=");
    }
    if (r instanceof Error)
      throw r;
    var K = {
      actual: o,
      expected: e,
      operator: c === void 0 ? "fail" : c,
      stackStartFn: b || _
    };
    r !== void 0 && (K.message = r);
    var fe = new O(K);
    throw C && (fe.message = C, fe.generatedMessage = !0), fe;
  }
  N.fail = _, N.AssertionError = O;
  function oe(o, e, r, c) {
    if (!r) {
      var b = !1;
      if (e === 0)
        b = !0, c = "No value argument passed to `assert.ok()`";
      else if (c instanceof Error)
        throw c;
      var I = new O({
        actual: r,
        expected: !0,
        message: c,
        operator: "==",
        stackStartFn: o
      });
      throw I.generatedMessage = b, I;
    }
  }
  function ae() {
    for (var o = arguments.length, e = new Array(o), r = 0; r < o; r++)
      e[r] = arguments[r];
    oe.apply(void 0, [ae, e.length].concat(e));
  }
  N.ok = ae, N.equal = function o(e, r, c) {
    if (arguments.length < 2)
      throw new W("actual", "expected");
    e != r && T({
      actual: e,
      expected: r,
      message: c,
      operator: "==",
      stackStartFn: o
    });
  }, N.notEqual = function o(e, r, c) {
    if (arguments.length < 2)
      throw new W("actual", "expected");
    e == r && T({
      actual: e,
      expected: r,
      message: c,
      operator: "!=",
      stackStartFn: o
    });
  }, N.deepEqual = function o(e, r, c) {
    if (arguments.length < 2)
      throw new W("actual", "expected");
    u === void 0 && y(), u(e, r) || T({
      actual: e,
      expected: r,
      message: c,
      operator: "deepEqual",
      stackStartFn: o
    });
  }, N.notDeepEqual = function o(e, r, c) {
    if (arguments.length < 2)
      throw new W("actual", "expected");
    u === void 0 && y(), u(e, r) && T({
      actual: e,
      expected: r,
      message: c,
      operator: "notDeepEqual",
      stackStartFn: o
    });
  }, N.deepStrictEqual = function o(e, r, c) {
    if (arguments.length < 2)
      throw new W("actual", "expected");
    u === void 0 && y(), h(e, r) || T({
      actual: e,
      expected: r,
      message: c,
      operator: "deepStrictEqual",
      stackStartFn: o
    });
  }, N.notDeepStrictEqual = re;
  function re(o, e, r) {
    if (arguments.length < 2)
      throw new W("actual", "expected");
    u === void 0 && y(), h(o, e) && T({
      actual: o,
      expected: e,
      message: r,
      operator: "notDeepStrictEqual",
      stackStartFn: re
    });
  }
  N.strictEqual = function o(e, r, c) {
    if (arguments.length < 2)
      throw new W("actual", "expected");
    te(e, r) || T({
      actual: e,
      expected: r,
      message: c,
      operator: "strictEqual",
      stackStartFn: o
    });
  }, N.notStrictEqual = function o(e, r, c) {
    if (arguments.length < 2)
      throw new W("actual", "expected");
    te(e, r) && T({
      actual: e,
      expected: r,
      message: c,
      operator: "notStrictEqual",
      stackStartFn: o
    });
  };
  var me = /* @__PURE__ */ g(function o(e, r, c) {
    var b = this;
    w(this, o), r.forEach(function(I) {
      I in e && (c !== void 0 && typeof c[I] == "string" && $(e[I]) && f(e[I], c[I]) ? b[I] = c[I] : b[I] = e[I]);
    });
  });
  function ge(o, e, r, c, b, I) {
    if (!(r in o) || !h(o[r], e[r])) {
      if (!c) {
        var C = new me(o, b), z = new me(e, b, o), K = new O({
          actual: C,
          expected: z,
          operator: "deepStrictEqual",
          stackStartFn: I
        });
        throw K.actual = o, K.expected = e, K.operator = I.name, K;
      }
      T({
        actual: o,
        expected: e,
        message: c,
        operator: I.name,
        stackStartFn: I
      });
    }
  }
  function d(o, e, r, c) {
    if (typeof e != "function") {
      if ($(e))
        return f(e, o);
      if (arguments.length === 2)
        throw new H("expected", ["Function", "RegExp"], e);
      if (a(o) !== "object" || o === null) {
        var b = new O({
          actual: o,
          expected: e,
          message: r,
          operator: "deepStrictEqual",
          stackStartFn: c
        });
        throw b.operator = c.name, b;
      }
      var I = Object.keys(e);
      if (e instanceof Error)
        I.push("name", "message");
      else if (I.length === 0)
        throw new X("error", e, "may not be an empty object");
      return u === void 0 && y(), I.forEach(function(C) {
        typeof o[C] == "string" && $(e[C]) && f(e[C], o[C]) || ge(o, e, C, r, I, c);
      }), !0;
    }
    return e.prototype !== void 0 && o instanceof e ? !0 : Error.isPrototypeOf(e) ? !1 : e.call({}, o) === !0;
  }
  function p(o) {
    if (typeof o != "function")
      throw new H("fn", "Function", o);
    try {
      o();
    } catch (e) {
      return e;
    }
    return Z;
  }
  function E(o) {
    return j(o) || o !== null && a(o) === "object" && typeof o.then == "function" && typeof o.catch == "function";
  }
  function v(o) {
    return Promise.resolve().then(function() {
      var e;
      if (typeof o == "function") {
        if (e = o(), !E(e))
          throw new J("instance of Promise", "promiseFn", e);
      } else if (E(o))
        e = o;
      else
        throw new H("promiseFn", ["Function", "Promise"], o);
      return Promise.resolve().then(function() {
        return e;
      }).then(function() {
        return Z;
      }).catch(function(r) {
        return r;
      });
    });
  }
  function P(o, e, r, c) {
    if (typeof r == "string") {
      if (arguments.length === 4)
        throw new H("error", ["Object", "Error", "Function", "RegExp"], r);
      if (a(e) === "object" && e !== null) {
        if (e.message === r)
          throw new k("error/message", 'The error message "'.concat(e.message, '" is identical to the message.'));
      } else if (e === r)
        throw new k("error/message", 'The error "'.concat(e, '" is identical to the message.'));
      c = r, r = void 0;
    } else if (r != null && a(r) !== "object" && typeof r != "function")
      throw new H("error", ["Object", "Error", "Function", "RegExp"], r);
    if (e === Z) {
      var b = "";
      r && r.name && (b += " (".concat(r.name, ")")), b += c ? ": ".concat(c) : ".";
      var I = o.name === "rejects" ? "rejection" : "exception";
      T({
        actual: void 0,
        expected: r,
        operator: o.name,
        message: "Missing expected ".concat(I).concat(b),
        stackStartFn: o
      });
    }
    if (r && !d(e, r, c, o))
      throw e;
  }
  function F(o, e, r, c) {
    if (e !== Z) {
      if (typeof r == "string" && (c = r, r = void 0), !r || d(e, r)) {
        var b = c ? ": ".concat(c) : ".", I = o.name === "doesNotReject" ? "rejection" : "exception";
        T({
          actual: e,
          expected: r,
          operator: o.name,
          message: "Got unwanted ".concat(I).concat(b, `
`) + 'Actual message: "'.concat(e && e.message, '"'),
          stackStartFn: o
        });
      }
      throw e;
    }
  }
  N.throws = function o(e) {
    for (var r = arguments.length, c = new Array(r > 1 ? r - 1 : 0), b = 1; b < r; b++)
      c[b - 1] = arguments[b];
    P.apply(void 0, [o, p(e)].concat(c));
  }, N.rejects = function o(e) {
    for (var r = arguments.length, c = new Array(r > 1 ? r - 1 : 0), b = 1; b < r; b++)
      c[b - 1] = arguments[b];
    return v(e).then(function(I) {
      return P.apply(void 0, [o, I].concat(c));
    });
  }, N.doesNotThrow = function o(e) {
    for (var r = arguments.length, c = new Array(r > 1 ? r - 1 : 0), b = 1; b < r; b++)
      c[b - 1] = arguments[b];
    F.apply(void 0, [o, p(e)].concat(c));
  }, N.doesNotReject = function o(e) {
    for (var r = arguments.length, c = new Array(r > 1 ? r - 1 : 0), b = 1; b < r; b++)
      c[b - 1] = arguments[b];
    return v(e).then(function(I) {
      return F.apply(void 0, [o, I].concat(c));
    });
  }, N.ifError = function o(e) {
    if (e != null) {
      var r = "ifError got unwanted exception: ";
      a(e) === "object" && typeof e.message == "string" ? e.message.length === 0 && e.constructor ? r += e.constructor.name : r += e.message : r += Y(e);
      var c = new O({
        actual: e,
        expected: null,
        operator: "ifError",
        message: r,
        stackStartFn: o
      }), b = e.stack;
      if (typeof b == "string") {
        var I = b.split(`
`);
        I.shift();
        for (var C = c.stack.split(`
`), z = 0; z < I.length; z++) {
          var K = C.indexOf(I[z]);
          if (K !== -1) {
            C = C.slice(0, K);
            break;
          }
        }
        c.stack = "".concat(C.join(`
`), `
`).concat(I.join(`
`));
      }
      throw c;
    }
  };
  function Q(o, e, r, c, b) {
    if (!$(e))
      throw new H("regexp", "RegExp", e);
    var I = b === "match";
    if (typeof o != "string" || f(e, o) !== I) {
      if (r instanceof Error)
        throw r;
      var C = !r;
      r = r || (typeof o != "string" ? 'The "string" argument must be of type string. Received type ' + "".concat(a(o), " (").concat(Y(o), ")") : (I ? "The input did not match the regular expression " : "The input was expected to not match the regular expression ") + "".concat(Y(e), `. Input:

`).concat(Y(o), `
`));
      var z = new O({
        actual: o,
        expected: e,
        message: r,
        operator: b,
        stackStartFn: c
      });
      throw z.generatedMessage = C, z;
    }
  }
  N.match = function o(e, r, c) {
    Q(e, r, c, o, "match");
  }, N.doesNotMatch = function o(e, r, c) {
    Q(e, r, c, o, "doesNotMatch");
  };
  function G() {
    for (var o = arguments.length, e = new Array(o), r = 0; r < o; r++)
      e[r] = arguments[r];
    oe.apply(void 0, [G, e.length].concat(e));
  }
  return N.strict = ie(G, N, {
    equal: N.strictEqual,
    deepEqual: N.deepStrictEqual,
    notEqual: N.notStrictEqual,
    notDeepEqual: N.notDeepStrictEqual
  }), N.strict.strict = N.strict, Re.exports;
}
var Rt = Ce();
function ze(a) {
  if (a.length === 0)
    return "";
  const s = `

**Related resources:**`, g = a.map(
    (l) => `- [${l.title}](${l.url})`
  );
  return [s, ...g].join(`

`);
}
const jt = "X-Request-Origin";
function Mt() {
  if (typeof window < "u")
    return window.location.href;
}
class xe extends Error {
  constructor(s, g = {}) {
    const { retryAfter: l = 1e3, data: i } = g;
    super(s), this.name = "RetriableError", this.message = s, this.retryAfter = l, this.data = i;
  }
}
class qt extends Error {
  constructor(s) {
    super(s), this.name = "TimeoutError", this.message = s;
  }
}
class Nt {
  constructor(s) {
    var l, i;
    Rt.strict(
      s.serverUrl,
      "You must define a serverUrl for the ConversationService"
    ), this.serverUrl = s.serverUrl.startsWith("/") ? new URL(
      s.serverUrl,
      window.location.protocol + "//" + window.location.host
    ).href : s.serverUrl;
    const g = new Headers({
      "Content-Type": "application/json",
      [`${jt}`]: Mt() ?? ""
    });
    this.fetchOptions = {
      ...s.fetchOptions ?? {},
      headers: this.mergeHeaders(
        g,
        (l = s.fetchOptions) != null && l.headers ? new Headers((i = s.fetchOptions) == null ? void 0 : i.headers) : new Headers()
      )
    };
  }
  mergeHeaders(s, g) {
    const l = new Headers();
    for (const [i, w] of s.entries())
      l.append(i, w);
    for (const [i, w] of g.entries())
      l.append(i, w);
    return l;
  }
  getUrl(s, g = {}) {
    if (!s.startsWith("/"))
      throw new Error(
        `Invalid path: ${s} - ConversationService paths must start with /`
      );
    const l = new URL(
      s.replace(/^\/?/, ""),
      // Strip leading slash (if present) to not clobber baseUrl path
      this.serverUrl.replace(/\/?$/, "/")
      // Add trailing slash to not lose last segment of baseUrl
    ), i = new URLSearchParams(g).toString();
    return i ? `${l}?${i}` : l.toString();
  }
  async createConversation() {
    const s = "/conversations", g = await fetch(this.getUrl(s), {
      ...this.fetchOptions,
      method: "POST"
    }), l = await g.json();
    if (g.status === 400)
      throw new Error(`Bad request: ${l.error}`);
    if (g.status === 429)
      throw new Error(`Rate limited: ${l.error}`);
    if (g.status >= 500)
      throw new Error(`Server error: ${l.error}`);
    return {
      ...l,
      conversationId: l._id
    };
  }
  async getConversation(s) {
    const g = `/conversations/${s}`, l = await fetch(this.getUrl(g), this.fetchOptions), i = await l.json();
    if (l.status === 404)
      throw new Error(`Conversation not found: ${s}`);
    if (l.status !== 200)
      throw new Error(`Failed to fetch conversation: ${i.error}`);
    return {
      ...i,
      conversationId: i._id
    };
  }
  async addMessage({
    conversationId: s,
    message: g
  }) {
    const l = `/conversations/${s}/messages`, i = await fetch(this.getUrl(l), {
      ...this.fetchOptions,
      method: "POST",
      body: JSON.stringify({ message: g })
    }), w = await i.json();
    if (i.status === 400)
      throw new Error(w.error);
    if (i.status === 404)
      throw new Error(`Conversation not found: ${w.error}`);
    if (i.status === 429)
      throw new Error(`Rate limited: ${w.error}`);
    if (i.status === 504)
      throw new qt(w.error);
    if (i.status >= 500)
      throw new Error(`Server error: ${w.error}`);
    return w;
  }
  async addMessageStreaming({
    conversationId: s,
    message: g,
    maxRetries: l = 0,
    onResponseDelta: i,
    onReferences: w,
    onMetadata: M,
    onResponseFinished: V,
    signal: k
  }) {
    const H = `/conversations/${s}/messages`;
    let X = 0, J = !0;
    const W = (O) => {
      const A = O;
      return A.type === "delta" && typeof A.data == "string" || A.type === "references" && typeof A.data == "object" || A.type === "metadata" && typeof A.data == "object" || A.type === "finished" && typeof A.data == "string";
    };
    await bt(this.getUrl(H, { stream: "true" }), {
      ...this.fetchOptions,
      // Need to convert Headers to plain object for fetchEventSource
      headers: Object.fromEntries(this.fetchOptions.headers),
      signal: k ?? null,
      method: "POST",
      body: JSON.stringify({ message: g }),
      openWhenHidden: !0,
      onmessage(O) {
        ue.env.NODE_ENV === "development" && console.debug("[EventSource]", O);
        const A = JSON.parse(O.data);
        if (!W(A))
          throw new Error(`Invalid event received from server: ${O.data}`);
        switch (A.type) {
          case "delta": {
            const Y = A.data.replaceAll("\\n", `
`);
            i(Y);
            break;
          }
          case "references": {
            w(A.data);
            break;
          }
          case "metadata": {
            M(A.data);
            break;
          }
          case "finished": {
            J = !1;
            const Y = A.data;
            V(Y);
            break;
          }
        }
      },
      async onopen(O) {
        if (!(O.ok && O.headers.get("content-type") === "text/event-stream")) {
          if (O.status === 400) {
            const A = await O.json();
            throw new Error(A.error ?? "Bad request");
          }
          throw O.status > 400 && O.status < 500 && O.status !== 429 ? new Error(`Chatbot stream error: ${O.statusText}`) : new xe(
            `Chatbot stream error: ${O.statusText}`,
            {
              retryAfter: 1e3,
              data: O
            }
          );
        }
      },
      onclose() {
        if (J)
          throw new xe("Chatbot stream closed unexpectedly");
      },
      onerror(O) {
        if (O instanceof xe) {
          if (J && X++ < l)
            return O.retryAfter;
          if (!O.data)
            throw new Error(O.message);
          if (O.data instanceof Response)
            O.data.json().then((Y) => {
              throw new Error(Y.error);
            });
          else
            throw new Error(O.message);
        } else if (O instanceof Error)
          throw new Error(O.message);
        throw O;
      }
    });
  }
  async rateMessage({
    conversationId: s,
    messageId: g,
    rating: l
  }) {
    const i = `/conversations/${s}/messages/${g}/rating`, w = await fetch(this.getUrl(i), {
      ...this.fetchOptions,
      method: "POST",
      body: JSON.stringify({ rating: l })
    });
    if (w.status === 204)
      return l;
    if (w.status >= 400) {
      const M = await w.json();
      throw new Error(M.error);
    }
    throw new Error(
      `Server encountered an unexpected status: ${w.status} (message: ${w.statusText})`
    );
  }
  async commentMessage({
    conversationId: s,
    messageId: g,
    comment: l
  }) {
    const i = `/conversations/${s}/messages/${g}/comment`, w = await fetch(this.getUrl(i), {
      ...this.fetchOptions,
      method: "POST",
      body: JSON.stringify({ comment: l })
    });
    if (w.status !== 204) {
      if (w.status >= 400) {
        const M = await w.json();
        throw new Error(M.error);
      }
      throw new Error(
        `Server encountered an unexpected status: ${w.status} (message: ${w.statusText})`
      );
    }
  }
}
function Ke() {
  const a = Date.now(), s = Math.floor(Math.random() * 1e5);
  return String(a + s);
}
function Ye(a, s, g) {
  const l = {
    id: Ke(),
    role: a,
    content: s,
    createdAt: (/* @__PURE__ */ new Date()).toISOString()
  };
  return g && (l.metadata = g), l;
}
const Ie = "streaming-response", et = {
  messages: [],
  error: "",
  isStreamingMessage: !1
};
function Pt(a, s) {
  function g(i) {
    return a.messages.findIndex(
      (M) => M.id === i
    );
  }
  function l() {
    const i = g(Ie), w = i === -1 ? null : a.messages[i];
    return {
      streamingMessageIndex: i,
      streamingMessage: w
    };
  }
  switch (s.type) {
    case "setConversation":
      return {
        ...s.conversation,
        error: ""
      };
    case "setConversationError":
      return {
        ...a,
        error: s.errorMessage
      };
    case "addMessage": {
      a.conversationId || console.error("Cannot addMessage without a conversationId");
      const i = Ye(
        s.role,
        s.content,
        s.metadata
      );
      return {
        ...a,
        messages: [...a.messages, i]
      };
    }
    case "setMessageContent": {
      if (!a.conversationId)
        return console.error("Cannot setMessageContent without a conversationId"), a;
      const i = g(s.messageId);
      if (i === -1)
        return console.error(
          `Cannot setMessageContent because message with id ${s.messageId} does not exist`
        ), a;
      const w = {
        ...a.messages[i],
        content: s.content
      };
      return {
        ...a,
        messages: [
          ...a.messages.slice(0, i),
          w,
          ...a.messages.slice(i + 1)
        ]
      };
    }
    case "setMessageMetadata": {
      if (!a.conversationId)
        return console.error("Cannot setMessageMetadata without a conversationId"), a;
      const i = g(s.messageId);
      if (i === -1)
        return console.error(
          `Cannot setMessageMetadata because message with id ${s.messageId} does not exist`
        ), a;
      const w = a.messages[i];
      if (w.role !== "assistant")
        return console.error(
          `Cannot setMessageMetadata because message with id ${s.messageId} is not an assistant message`
        ), a;
      const M = {
        ...w,
        metadata: s.metadata
      };
      return {
        ...a,
        messages: [
          ...a.messages.slice(0, i),
          M,
          ...a.messages.slice(i + 1)
        ]
      };
    }
    case "deleteMessage": {
      if (!a.conversationId)
        return console.error("Cannot deleteMessage without a conversationId"), a;
      const i = g(s.messageId);
      return i === -1 ? (console.error(
        `Cannot deleteMessage because message with id ${s.messageId} does not exist`
      ), a) : {
        ...a,
        messages: [
          ...a.messages.slice(0, i),
          ...a.messages.slice(i + 1)
        ]
      };
    }
    case "rateMessage": {
      if (!a.conversationId)
        return console.error("Cannot rateMessage without a conversationId"), a;
      const i = g(s.messageId);
      if (i === -1)
        return console.error(
          `Cannot rateMessage because message with id ${s.messageId} does not exist`
        ), a;
      const w = {
        ...a.messages[i],
        rating: s.rating
      };
      return {
        ...a,
        messages: [
          ...a.messages.slice(0, i),
          w,
          ...a.messages.slice(i + 1)
        ]
      };
    }
    case "createStreamingResponse": {
      if (!a.conversationId)
        return console.error(
          "Cannot createStreamingResponse without a conversationId"
        ), a;
      let { streamingMessage: i } = l();
      return i ? (console.error(
        "Cannot createStreamingResponse because a streamingMessage already exists"
      ), a) : (i = {
        ...Ye("assistant", s.data),
        id: Ie
      }, {
        ...a,
        isStreamingMessage: !0,
        streamingMessage: i,
        messages: [...a.messages, i]
      });
    }
    case "appendStreamingResponse": {
      if (!a.conversationId)
        return console.error(
          "Cannot appendStreamingResponse without a conversationId"
        ), a;
      const { streamingMessage: i, streamingMessageIndex: w } = l();
      if (!i)
        return console.error(
          "Cannot appendStreamingResponse without a streamingMessage. Make sure to dispatch createStreamingResponse first."
        ), a;
      const M = {
        ...i,
        content: i.content + s.data
      };
      return {
        ...a,
        messages: De(
          a.messages,
          w,
          M
        )
      };
    }
    case "finishStreamingResponse": {
      const { streamingMessage: i, streamingMessageIndex: w } = l();
      if (!i)
        return console.error(
          "Cannot finishStreamingResponse without a streamingMessage"
        ), a;
      const M = {
        ...i,
        id: s.messageId
      };
      return {
        ...a,
        isStreamingMessage: !1,
        streamingMessage: void 0,
        messages: De(
          a.messages,
          w,
          M
        )
      };
    }
    case "cancelStreamingResponse": {
      const { streamingMessage: i, streamingMessageIndex: w } = l();
      if (!i)
        return console.error(
          "Cannot cancelStreamingResponse without a streamingMessage"
        ), a;
      const M = ft(
        a.messages,
        w
      );
      return {
        ...a,
        isStreamingMessage: !1,
        streamingMessage: void 0,
        messages: M
      };
    }
    default:
      throw console.error("Unhandled action", s), new Error("Unhandled action type");
  }
}
function Ut(a = {}) {
  const s = rt(() => new Nt({
    serverUrl: a.serverBaseUrl ?? {}.VITE_SERVER_BASE_URL,
    fetchOptions: a.fetchOptions
  }), [a.serverBaseUrl, a.fetchOptions]), [g, l] = nt(
    Pt,
    et
  ), i = (...q) => {
    l(...q);
  }, w = (q) => {
    i({ type: "setConversation", conversation: q });
  }, M = (q) => {
    i({ type: "setConversationError", errorMessage: q });
  }, V = async () => {
    try {
      const q = await s.createConversation();
      w({
        ...q,
        error: ""
      });
    } catch (q) {
      const j = typeof q == "string" ? q : q instanceof Error ? q.message : "Failed to create conversation.";
      console.error(j), M(j);
    }
  }, k = async ({
    role: q,
    content: j
  }) => {
    if (!g.conversationId) {
      console.error("Cannot addMessage without a conversationId");
      return;
    }
    const $ = lt() && (a.shouldStream ?? !0), ie = new AbortController();
    let te = !1, f = !$, u = null, h = null, y = [], D = [];
    const N = 50, Z = setInterval(() => {
      const [_, ...oe] = y;
      y = oe, _ && i({ type: "appendStreamingResponse", data: _ });
      const ae = te && y.length === 0;
      h && ae && (dt(
        /```/g,
        D.join("")
      ) % 2 !== 0 && i({
        type: "appendStreamingResponse",
        data: "\n```\n\n"
      }), i({
        type: "appendStreamingResponse",
        data: ze(h)
      }), h = null), !f && ae && (u || (u = Ke()), i({
        type: "finishStreamingResponse",
        messageId: u
      }), f = !0);
    }, N);
    try {
      if (i({ type: "addMessage", role: q, content: j }), $)
        i({ type: "createStreamingResponse", data: "" }), await s.addMessageStreaming({
          conversationId: g.conversationId,
          message: j,
          maxRetries: 0,
          onResponseDelta: async (_) => {
            y = [...y, _], D = [...D, _];
          },
          onReferences: async (_) => {
            h = _;
          },
          onMetadata: async (_) => {
            X({
              messageId: Ie,
              metadata: _
            });
          },
          onResponseFinished: async (_) => {
            u = _, te = !0;
          },
          signal: ie.signal
        });
      else {
        i({ type: "createStreamingResponse", data: "" });
        const _ = await s.addMessage({
          conversationId: g.conversationId,
          message: j
        });
        h = _.references ?? null;
        const oe = h ? ze(h) : "";
        i({ type: "cancelStreamingResponse" }), i({
          type: "addMessage",
          role: "assistant",
          content: _.content + oe,
          metadata: _.metadata
        });
      }
    } catch (_) {
      ie.abort(), console.error(`Failed to add message: ${_}`);
      const oe = _ instanceof Error ? _.message : String(_);
      throw i({ type: "cancelStreamingResponse" }), clearInterval(Z), M(oe), _;
    }
    let T;
    return new Promise((_) => {
      T = setInterval(() => {
        f && (clearInterval(Z), clearInterval(T), _());
      }, N);
    });
  }, H = async (q, j) => {
    if (!g.conversationId) {
      console.error("Cannot setMessageContent without a conversationId");
      return;
    }
    i({ type: "setMessageContent", messageId: q, content: j });
  }, X = async ({
    messageId: q,
    metadata: j
  }) => {
    if (!g.conversationId) {
      console.error("Cannot setMessageMetadata without a conversationId");
      return;
    }
    i({ type: "setMessageMetadata", messageId: q, metadata: j });
  }, J = async (q) => {
    if (!g.conversationId) {
      console.error("Cannot deleteMessage without a conversationId");
      return;
    }
    i({ type: "deleteMessage", messageId: q });
  }, W = async (q, j) => {
    if (!g.conversationId) {
      console.error("Cannot rateMessage without a conversationId");
      return;
    }
    await s.rateMessage({
      conversationId: g.conversationId,
      messageId: q,
      rating: j
    }), i({ type: "rateMessage", messageId: q, rating: j });
  }, O = async (q, j) => {
    if (!g.conversationId) {
      console.error("Cannot commentMessage without a conversationId");
      return;
    }
    await s.commentMessage({
      conversationId: g.conversationId,
      messageId: q,
      comment: j
    });
  }, A = g.messages.find(
    (q) => q.id === Ie
  );
  return {
    ...g,
    createConversation: V,
    endConversationWithError: M,
    streamingMessage: A,
    addMessage: k,
    setMessageContent: H,
    setMessageMetadata: X,
    deleteMessage: J,
    rateMessage: W,
    commentMessage: O,
    switchConversation: async (q) => {
      try {
        const j = await s.getConversation(
          q
        );
        w({
          ...j,
          error: ""
        });
      } catch (j) {
        const $ = typeof j == "string" ? j : j instanceof Error ? j.message : "Failed to switch conversation.";
        throw console.error($), j;
      }
    }
  };
}
const At = ot({
  ...et,
  createConversation: async () => {
  },
  endConversationWithError: () => {
  },
  addMessage: async () => {
  },
  setMessageContent: async () => {
  },
  setMessageMetadata: async () => {
  },
  deleteMessage: async () => {
  },
  rateMessage: async () => {
  },
  commentMessage: async () => {
  },
  switchConversation: async () => {
  }
});
function $t({
  children: a,
  conversation: s
}) {
  return /* @__PURE__ */ tt.jsx(At.Provider, { value: s, children: a });
}
export {
  $t as C,
  At as a,
  Ut as u
};
